module.exports = __webpack_public_path__ + "static/media/aurora-borealis-3877316_640.257909db.jpg";